// src/components/FloatingCallButton.jsx
import React from "react";

/**
 * Floating call button (bottom-right).
 * Props:
 *  - phone: string like "+40000000000"
 *  - label: accessible label (optional, defaults to "Sună acum" / "Call now")
 *  - className: extra Tailwind classes (optional)
 */
export default function FloatingCallButton({
  phone = "+40000000000",
  label = "Sună acum",
  className = "",
}) {
  const href = `tel:${phone.replace(/\s+/g, "")}`;

  // Optional: lightweight GTM/GA event
  const onClick = () => {
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: "call_click",
        phone,
        location: "floating_button",
      });
    }
  };

  return (
    <a
      href={href}
      onClick={onClick}
      aria-label={label}
      className={[
        "fixed right-4 bottom-4 z-[9998]",
        // button look
        "group inline-flex items-center justify-center",
        "h-14 w-14 rounded-full",
        "bg-redglass-primary text-white",
        "shadow-brand ring-1 ring-redglass-ring/40",
        "hover:bg-redglass-dark active:translate-y-px",
        "transition focus:outline-none focus-visible:ring-2 focus-visible:ring-redglass-primary/60",
        // safe tap target + optional extra classes
        className,
      ].join(" ")}
    >
      {/* phone icon */}
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="h-6 w-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.86.31 1.7.57 2.5a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l1.67-1.67a2 2 0 0 1 2.11-.45c.8.26 1.64.45 2.5.57A2 2 0 0 1 22 16.92z" />
      </svg>

      {/* ping ripple (subtle) */}
      <span className="pointer-events-none absolute inline-flex h-full w-full animate-ping rounded-full opacity-20 bg-redglass-primary" />
    </a>
  );
}
